<template>
  <el-dialog :visible.sync="dialogVisible" width="50%">
    <el-form ref="myform" :model="myform" label-width="120px" :rules="rules">
      <el-form-item label="俱乐部名称" prop="jlbName">
        <el-input v-model="myform.jlbName" />
      </el-form-item>
      <el-form-item label="俱乐部成员">
        <el-button
          icon="el-icon-plus"
          type="success"
          size="mini"
          @click="chickPlus"
          >添加</el-button
        >
        <el-table :data="myform.userList" align="center">
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <el-form-item
                :prop="`userList.${scope.$index}.chinaName`"
                :rules="rules.chinaName"
              >
                <el-input v-model="scope.row.chinaName" />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="电话">
            <template slot-scope="scope">
              <el-form-item
                :prop="'userList.' + scope.$index + '.phone'"
                :rules="rules.phone"
              >
                <el-input v-model="scope.row.phone" />
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleCreate">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: true,
      myform: {
        jlbName: '',
        userList: [
          {
            chinaName: '',
            phone: ''
          }
        ]
      },
      rules: {
        jlbName: [{ required: true, message: '必填', trigger: 'blur' }],
        chinaName: [{ required: true, message: '必填', trigger: 'blur' }],
        phone: [{ required: true, message: '必填', trigger: 'blur' }]
      }
    }
  },

  methods: {
    // 添加一行
    chickPlus () {
      this.myform.userList.push({
        chinaName: '',
        phone: ''
      })
    },
    handleCreate () {
      this.$refs['myform'].validate((valid) => {
        if (valid) {
          console.log(this.myform)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/test.vue